import { Check, Visibility, VisibilityOff } from "@mui/icons-material"
import { TextField, InputAdornment, TextFieldProps } from "@mui/material"
import { forwardRef, useState } from "react"

type WakacjeTextInputProps = {
  valid?: any
  errors?: any
  id?: any
  type?: any
  forceValidEndorsement?: any
  touched?: any
  error?: any
  placeholder?: any
  rows?: any
  multiline?: any
  disabled?: any
  inputProps?: any
  endAdornment?: any
  passwordField?: any
  className?: any
}

export const WakacjeTextInput = forwardRef<
  HTMLInputElement,
  TextFieldProps & WakacjeTextInputProps
>((props, ref) => {
  const {
    label,
    variant,
    onChange,
    onBlur,
    value,
    name,
    size,
    required,
    valid,
    margin,
    errors,
    type,
    touched,
    fullWidth,
    id,
    forceValidEndorsement,
    inputRef,
    error,
    placeholder,
    rows,
    multiline,
    disabled,
    endAdornment,
    passwordField,
    className
  } = props

  const [showPassword, setShowPassword] = useState(false)

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <TextField
      id={id}
      ref={ref}
      inputRef={inputRef}
      label={label}
      // variant={variant}
      style={{ background: "white" }}
      size={size}
      margin={margin ?? "normal"}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      name={name}
      required={required}
      color={valid ? "success" : undefined}
      type={passwordField ? (showPassword ? "text" : "password") : type}
      fullWidth={fullWidth}
      placeholder={placeholder ? placeholder : undefined}
      rows={rows ? rows : undefined}
      multiline={multiline ? true : false}
      disabled={disabled}
      InputProps={{
        endAdornment: passwordField ? (
          <InputAdornment position="end">
            {showPassword ? (
              <Visibility
                className="cursor-pointer"
                onClick={handleTogglePassword}
              />
            ) : (
              <VisibilityOff
                className="cursor-pointer"
                onClick={handleTogglePassword}
              />
            )}
          </InputAdornment>
        ) : forceValidEndorsement ||
          (!!errors && !errors[name] && value !== "") ? (
          <InputAdornment position="end">
            <Check color="success" />
          </InputAdornment>
        ) : (
          endAdornment
        )
      }}
      error={error ? error : touched && errors && touched[name] && errors[name]}
      helperText={
        error
          ? error
          : touched && errors && touched[name]
          ? errors[name]
          : undefined
      }
      className={className}
    />
  )
})
